export var msaUserHintKey = 'MsaUserHint';
export var paintEwFirstMarker = 'Paint_EdgeworthFirst';
export var safeLinksRegex = /^https?:\/\/\S+\.safelinks\.protection\.outlook\.com/;
/* Recent */
export var recentQueryKey = [
    'EdgeworthData',
    "Recent" /* QuerySubtype.Recent */,
];
/* Favorites */
export var favoritesQueryKey = [
    'EdgeworthData',
    "Favorites" /* QuerySubtype.Favorites */,
];
/* Settings */
export var SettingsCacheKeyPrefix = '_EdgeworthSettings';
/* Metafolders */
export var documentsCardId = 'ew-documents';
//# sourceMappingURL=Constants.js.map